//
//
//
//
//

/**
 * @noteType component
 * @name DirectiveFor
 * @tagName mt-directive-for
 * @desc 列表容器
 * @type list|directive
 * @directiveName v-for
 * @wrapClassName mint-directive-for
 * @html
 * <mt-directive-for></mt-directive-for>
 */
export default {
    name: 'mt-directive-for',
    methods: {
        handleClick(evt) {
            this.$emit('click', evt);
        }
    },
    props: {}
};

/**
 * @noteType external
 * @content
 {
   "containerItem": [
      {
        "tagName": "LayoutContainer",
        "attrs": {
          "v-for": "n in 3"
        }
      }
    ]
 }
 */



// WEBPACK FOOTER //
// ./packages/directive-for/src/directive-for.vue